<template>
  <div>
    <ul class="nav nav-tabs tw-mb-6 tw-mt-12">
       <li class="nav-item" :class="{ active: isActive('home'), 'tw-font-bold': isActive('home') }">
        <a class="nav-link" @click.prevent="setActive('home')" href="#home">Envios com sucesso</a>
      </li>
      <li class="nav-item" :class="{ active: isActive('errors'), 'tw-font-bold': isActive('errors') }">
        <a class="nav-link" @click.prevent="setActive('errors')" href="#errors">Erros ao enviar <span v-if="tab_error" ><span class="tw-rounded-full tw-bg-red-400 tw-font-semibold tw-text-white tw-px tw-px-1 tw-text-xs tw-ml-1 ">{{ tab_error }}</span></span> </a>
      </li>
    </ul>
    <div class="tab-content py-3" id="myTabContent">
      <div :class="{ 'tw-hidden': ! isActive('home'), 'tw-block': ! isActive('home'), 'tw-overflow-scroll': true, 'md:tw-overflow-visible': true }" id="home">
        <table class="tw-mt-10 tw-text-sm tw-w-full table tw-font-sans">
          <thead class="tw-text-gray-700">
            <tr class="tw-border-b-2">
              <th class="tw-px-4 tw-py-4 tw-w-1/5">Paciente</th>
              <th class="tw-px-4 tw-py-4 tw-w-1/6">Data do envio</th>
              <th class="tw-px-4 tw-py-4 tw-w-1/6">Campanha</th>
              <th class="tw-px-4 tw-py-4 tw-w-1/7">Método</th>
              <th class="tw-px-4 tw-py-4 tw-w-1/3">Mensagem enviada</th>
            </tr>
          </thead>
          <tbody class="tw-text-sm tw-text-gray-600">
            <tr v-for="message in messages">
              <td class="tw-px-4 tw-py-3">
                <a :href="`/patients/${message.patient_id}`">
                  {{ message.full_name }}
                </a>
              </td>
              <td class="tw-px-4 tw-py-3">{{ message.created_at }}</td>
              <td class="tw-px-4 tw-py-3">
                <span :class="`fa ${getIconClass(message.campaign_name)}`"></span> {{ message.campaign_name }}
              </td>
              <td class="tw-px-4 tw-py-3">{{ message.gateway.toUpperCase() }}</td>
              <td class="tw-px-4 tw-py-3" v-if="message.body.length < 50"><span>{{ message.body }}</span></td>
              <td class="tw-px-4 tw-py-3" v-else><span v-bind:title="message.body">{{ message.body.substring(0,50)+"..." }}</span></td>
            </tr>
            <tr v-if="messages.length == 0" >
              <td colspan="4" class="tw-pt-5">Nenhuma mensagem automática foi enviada ainda. <br> Após a ativação das campanhas, pode demorar até 24h para iniciar o envio.</td>
            </tr>
          </tbody>
        </table>
        <div class="search-footer tw-mx-0">
          <div>
            <div class="patient-footer-show-result">Mostrando {{ messages.length }} de {{ totalMessage }} resultados</div>
            <div class="patient-footer-pages" v-if="messagesRemaining > 0">
              <a @click.prevent="fetchMore" class="tw-text-blue-600">
                Mostrar {{ messagesRemaining > 20 ? 20 : messagesRemaining }} mais
              </a>
            </div>
          </div>
          <div>
            Baixar lista completa:
            <a href="/campaigns.xlsx" class="tw-text-blue-600">Excel</a>
          </div>
        </div>
      </div>
      <div :class="{ 'tw-hidden': ! isActive('errors'), 'tw-block': ! isActive('home'), 'tw-overflow-scroll': true, 'md:tw-overflow-visible': true }" id="errors">
        <div class="tw-ml-3 tw-mr-3 tw-mt-3 tw-mb-5 tw-bg-orange-100 tw-border-l-4 tw-border-orange-500 tw-text-orange-700 tw-p-4" role="alert">
          <p>Veja aqui a lista de pacientes que tiveram problemas no recebimento das mensagens</p>
        </div>
        <table class="tw-mt-5 tw-text-sm tw-w-full table tw-font-sans">
          <thead class="tw-text-gray-700">
            <tr class="tw-border-b-2">
              <th class="tw-px-4 tw-py-4 tw-w-1/3">Paciente</th>
              <th class="tw-px-4 tw-py-4 tw-w-1/6">Celular</th>
              <th class="tw-px-4 tw-py-4 tw-w-1/6">Data</th>
              <th class="tw-px-4 tw-py-4 tw-w-1/3">Erro retornado</th>
              <th class="tw-px-4 tw-py-4 tw-w-1/4"></th>
            </tr>
          </thead>
          <tbody class="tw-text-sm tw-text-gray-600">
            <tr v-for="error_log in error_logs">
              <td class="tw-px-4 tw-py-3"><a v-bind:href="'patients/' + error_log.patient_id ">{{ error_log.patient_name }}</a></td>
              <td class="tw-px-4 tw-py-3">{{ error_log.cellphone }}</td>
              <td class="tw-px-4 tw-py-3">{{ error_log.created_at }}</td>
              <td class="tw-px-4 tw-py-3">{{ error_log.description }}</td>
              <td class="tw-px-4 tw-py-3 tw-text-sm tw-text-gray-700"><a v-bind:href="'patients/' + error_log.patient_id + '/edit' ">Corrigir</a></td>
            </tr>
            <tr v-if="error_logs.length == 0" >
              <td colspan="4" class="tw-pt-5">Nenhum erro foi identificado. </td>
            </tr>
          </tbody>
        </table>
        <div class="search-footer tw-mx-0">
          <div>
            <div class="patient-footer-show-result">
              Mostrando {{ error_logs.length }} de {{ totalMessageError }} resultados
            </div>
            <div class="patient-footer-pages" v-if="messagesRemainingError > 0">
              <a
                @click.prevent="fetchMoreError"
                class="tw-text-blue-600"
              >Mostrar {{ messagesRemainingError > 10 ? 10 : messagesRemainingError }} mais</a>
            </div>
          </div>
          <div>
            <small>** Mensagens que apresentam erro no envio não são cobradas</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        messages: [],
        error_logs: [],
        page: 1,
        page_error: 1,
        totalMessage: 0,
        totalMessageError: 0,
        smsError: false,
        tab_error: false,
        activeItem: 'home'
      };
    },

    mounted() {
      axios
        .get('/campaigns/sending_history')
        .then(response => {
          this.messages = response.data.history,
          this.totalMessage = response.data.total_messages
          this.tab_error = response.data.total_messages_error_tab > 0 ? response.data.total_messages_error_tab : false
        })
    },
    computed: {
      messagesRemaining() {
        return this.totalMessage - this.messages.length;
      },
      messagesRemainingError() {
        return this.totalMessageError - this.error_logs.length;
      }
    },
    methods: {
      fetchMore() {
        axios
        .get(`/campaigns/sending_history?page=${this.page + 1}`)
        .then(response => {
          this.messages = this.messages.concat(response.data.history)
          this.page = this.page + 1
        });
      },
      isActive (menuItem) {
        return this.activeItem === menuItem
      },
      setActive (menuItem) {
        if (menuItem == "errors" && ! this.smsError) {
          axios
          .get(`/campaigns/sending_history_error?page=1`)
          .then(response => {
            this.error_logs = response.data.error
            this.totalMessageError = response.data.total_messages_error
            this.smsError = true
          })
        }
        this.activeItem = menuItem
      },

      fetchMoreError() {
        axios
        .get(`/campaigns/sending_history_error?page=${this.page_error + 1}`)
        .then(response => {
          this.error_logs = this.error_logs.concat(response.data.error)
          this.page_error = this.page_error + 1
        })
      },
      getIconClass(campaign_name){
        const defaultIcon = "fa-check"
        const icons = {
          'Aniversariantes': "fa-gift",
          'Retorno semestral': "fa-undo",
          'Inadimplentes': "fa fa-dollar",
        }

        return icons[campaign_name] ? icons[campaign_name] : defaultIcon;
      }
    }
  }
</script>
